export const SMTP_SERVER_DEFAULT_FORM = "configSmtpServerDefaultForm";
export const DELETE_SMTP_SERVER_DEFAULT_FORM = "configDeleteSmtpServerDefaultForm";